import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 mt-6">Strona nie została znaleziona</h1>
        <p className="mt-2 text-base text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-600">Opowiedz mi więcej o tej stronie, a pomogę ją wygenerować</p>
        <a
          href="/"
          className="inline-block mt-8 bg-foreground-900 text-background-50 px-6 py-3 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          Powrót do strony głównej
        </a>
      </div>
    </div>
  );
}